export const BOOKING_STATUS_STYLE = {
  pending: "bg-amber-100 text-amber-700",
  awaiting_payment: "bg-orange-100 text-orange-700",
  confirmed: "bg-green-100 text-green-700",
  completed: "bg-blue-100 text-blue-700",
  rejected: "bg-red-100 text-red-700",
  cancelled: "bg-stone-200 text-stone-600",
  payment_failed: "bg-red-100 text-red-700",
  payment_expired: "bg-stone-200 text-stone-600",
  refund_pending: "bg-purple-100 text-purple-700",
  refunded: "bg-teal-100 text-teal-700",
};

export const BOOKING_STATUS_LABEL = {
  pending: "Pending",
  awaiting_payment: "Awaiting Payment",
  confirmed: "Confirmed",
  completed: "Completed",
  rejected: "Rejected",
  cancelled: "Cancelled",
  payment_failed: "Payment Failed",
  payment_expired: "Payment Expired",
  refund_pending: "Refund Pending",
  refunded: "Refunded",
};

export const fmtStatus = (s) => BOOKING_STATUS_LABEL[s] || s;

export const PAYMENT_STATUS_LABEL = {
  unpaid: "Unpaid",
  created: "Awaiting Payment",
  pending: "Pending",
  paid: "Paid",
  failed: "Failed",
  refund_pending: "Refund Pending",
  refunded: "Refunded",
};
